// extracted by mini-css-extract-plugin
module.exports = {"discountChid_test":"DiscountChip_discountChid_test__DA4JM","discountChid_cart":"DiscountChip_discountChid_cart__j2Hhl"};